import React from "react";
import {Image} from 'react-bootstrap';
import Header from "../components/Header/Header";
import Summary from "../components/About/Summary";
import AboutBand from "../components/About/AboutBand";
import Recruit from "../components/About/Recruit";
import ProjictCoverage from "../components/Index/ProjictCoverage";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop/BackToTop";

import './About.css'

class About extends React.Component {
  render() {
    return (
      <div className="successCase">
      {/* 页头 */}
      <Header pageName="about" />

      {/* 页头图 */}
      <Image src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/bg_about.webp" className="about_bg" />

      {/* 公司简介 */}
      <Summary />

      {/* 中部banner */}
      <AboutBand />

      {/* 招聘信息 */}
      <Recruit />

      {/* 项目覆盖 */}
      <ProjictCoverage />

      {/* 页脚 */}
      <Footer />

      {/* 回到顶部 */}
      <BackToTop />
      </div>
    )
  }
}

export default About
